<div *ngIf="checkViewMode('edit') && attribute.key != 'Duração do projeto'"
  [class]="'form-group txt_'+getOptionByKey(attribute,'identifier')">
  <label for="">
    {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : attribute.key}}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info"
    [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <input class="form-control m-input" (keypress)="onMaxlength($event, getOptionByKey(attribute,'maxlength'))"
    [type]="ngGetComponentType(attribute)" [(ngModel)]="attribute.value"
    [tabindex]="getOptionByKey(attribute,'tabIndex')" [disabled]="getOptionByKey(attribute,'disabled')"
    [maxlength]="getOptionByKey(attribute,'maxlength')" [required]="getOptionByKey(attribute,'required')"
    [placeholder]="getOptionByKey(attribute,'placeholder')" [id]="getOptionByKey(attribute,'identifier')"
    (blur)="ngBlurInput(getOptionByKey(attribute,'identifier'))"
    (change)="onChange()"
    mask="{{ getMask() }}">
</div>

<div *ngIf="checkViewMode('view')">
  <p><span>{{ getLabel() }}: </span>
    <a *ngIf="isLink(); else isNotLink" href="{{attribute.value}}" rel="noopener noreferrer" target="_blank">{{ getTitle() }}</a>
    <ng-template #isNotLink>{{ getTitle() }}</ng-template>
  </p>
</div>
